import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ScrollArea } from "@/components/ui/scroll-area";
import { MessageActions } from "./MessageActions";

interface MessagesTableProps {
  filteredMessages: any[];
  mockOwners: any[];
  mockProperties: any[];
  onViewMessage: (schedule: any) => void;
  onDeleteMessage: (scheduleId: string) => void;
}

export function MessagesTable({ 
  filteredMessages, 
  mockOwners, 
  mockProperties, 
  onViewMessage,
  onDeleteMessage 
}: MessagesTableProps) {
  return (
    <ScrollArea className="h-[500px] rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Proprietário</TableHead>
            <TableHead>Imóvel</TableHead>
            <TableHead>Intervalo</TableHead>
            <TableHead>Próximo Envio</TableHead>
            <TableHead>Horário</TableHead>
            <TableHead className="w-[200px]">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredMessages.map((schedule) => {
            const owner = mockOwners.find(o => o.id === schedule.ownerId);
            const property = mockProperties.find(p => p.id === schedule.propertyId);
            return (
              <TableRow key={schedule.id}>
                <TableCell className="font-medium">{owner?.name}</TableCell>
                <TableCell>{property?.title}</TableCell>
                <TableCell>
                  {schedule.interval === "30days" ? "30 dias" : "60 dias"}
                </TableCell>
                <TableCell>
                  {format(schedule.nextDate, "dd/MM/yyyy", { locale: ptBR })}
                </TableCell>
                <TableCell>
                  {format(schedule.nextDate, "HH:mm")}
                </TableCell>
                <TableCell>
                  <MessageActions
                    schedule={schedule}
                    onViewMessage={onViewMessage}
                    onDeleteMessage={onDeleteMessage}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </ScrollArea>
  );
}